export default __webpack_public_path__ + "static/media/pending.93702b89.svg";